import type { ExtensionsConfigOptions } from '../../types';

export const extConfig: ExtensionsConfigOptions = {
  muro: false,
  bold: false,
  italic: false,
  strikethrough: false,
  underline: false,
  bulletList: false,
  orderedList: false,
  horizontalRuler: false,
  link: true,
  emote: false,
  deviation: false,
  deviationThumb: false,
  gallery: false,
  anchor: false,
  blockDragging: false,
  blockquote: false,
  heading: false,
  mention: false,
  paste: true,
  textAlignment: false,
  textColor: false,
  textFont: false,
  textHighlight: false,
  history: true,
  allowUploads: false,
  spinner: false,
  gif: false,
  indent: false,
  daVideo: false,
  hashtag: false,
  characterCount: true,
};
